module.exports = __webpack_public_path__ + "components/MapControl/svg/Leśniczówka_gajówka.svg?989a4dc9";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Leśniczówka_gajówka.svg
// module id = 1992
// module chunks = 0